var render = function render(){var _vm=this,_c=_vm._self._c;return _c('DsModal',{attrs:{"show-close":"","is-open":"","title":"Rename template"},on:{"close":function($event){return _vm.$emit('close')}}},[_c('RenameTemplateForm',{attrs:{"template":_vm.template},on:{"saved":function($event){return _vm.$emit('saved', $event)}}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }